/**
 * Video Player Functionality
 * Handles video overlay clicks and Vimeo player initialization
 */
class VideoPlayer {
  constructor() {
    this.initElements();
    this.bindEvents();
  }

  /**
   * Initialize DOM elements
   */
  initElements() {
    this.videoContainer = document.querySelector('.video-container');
    this.videoOverlay = document.querySelector('.video-overlay');
    this.videoPlayer = document.querySelector('#vimeo-player-1');
    this.playButton = document.querySelector('.video-overlay svg');
    this.playText = document.querySelector('.play-text');
    this.videoTextBox = document.querySelector('.column.test .text');
    
    if (!this.videoContainer || !this.videoOverlay || !this.videoPlayer) {
      console.warn('Video player elements not found');
      return;
    }
  }

  /**
   * Bind event listeners
   */
  bindEvents() {
    if (!this.videoOverlay) return;
    
    // Handle click on video overlay
    this.videoOverlay.addEventListener('click', (e) => {
      e.preventDefault();
      this.playVideo();
    });

    // Handle click on play button specifically
    if (this.playButton) {
      this.playButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.playVideo();
      });
    }

    // Handle click on play text
    if (this.playText) {
      this.playText.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.playVideo();
      });
    }
  }

  /**
   * Play the video
   */
  playVideo() {
    this.videoTextBox.classList.add('hide-on-mobile');
    if (!this.videoPlayer || !this.videoOverlay) return;

    // Update video container background to black
    this.videoContainer.style.backgroundColor = 'black';
    this.videoContainer.style.backgroundImage = '';
    
    // Hide the overlay
    this.videoOverlay.style.display = 'none';
    
    // Show the video player
    this.videoPlayer.style.display = 'block';
    
    // Get the iframe and add autoplay parameter
    const iframe = this.videoPlayer.querySelector('iframe');
    if (iframe) {
      const currentSrc = iframe.src;
      if (!currentSrc.includes('autoplay=1')) {
        const separator = currentSrc.includes('?') ? '&' : '?';
        iframe.src = currentSrc + separator + 'autoplay=1';
      }
      // Add data-ready attribute
      iframe.setAttribute('data-ready', 'true');
    }
  }

  /**
   * Reset video player to initial state
   */
  resetVideo() {
    if (!this.videoPlayer || !this.videoOverlay) return;
    const bgImage = "{{ section.settings.panel_image | img_url: '2048x' }}";
    // Restore original background
    this.videoContainer.style.backgroundColor = '';
    // this.videoContainer.style.backgroundImage = 'url("https://hamiltonnohead.wpengine.com/wp-content/uploads/2022/04/HAM_Homepage-Video-Still.webp")';
    this.videoContainer.style.backgroundImage = `url('${bgImage}')`;


    // Show overlay, hide video player
    this.videoOverlay.style.display = 'flex';
    this.videoPlayer.style.display = 'none';
    
    // Remove autoplay parameter and data-ready attribute
    const iframe = this.videoPlayer.querySelector('iframe');
    if (iframe) {
      const currentSrc = iframe.src;
      iframe.src = currentSrc.replace(/[?&]autoplay=1/, '');
      iframe.removeAttribute('data-ready');
    }
  }
}

// Initialize video player when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new VideoPlayer();
}); 